import { logEvent } from './logGaEvent'

export const logSortByOpen = () => {
  logEvent('sort', {
    sort_name: 'sort_by_open',
    product_name: 'air',
    page_name: 'listings',
  })
}

export const logSortByOptionSelect = (sortOption = '') => {
  logEvent('sort', {
    sort_name: 'sort_by',
    sort_item: sortOption.toLowerCase(),
    product_name: 'air',
    page_name: 'listings',
  })
}
